<template>
    <div class="col-sm-12 nopads">
        <div class="search-form p-2">
            <div class="col-sm-12 search-form-title">
                <font-awesome-icon icon="search" />
                {{ $t('common.search') }}
            </div>

            <!-- Form for Search -->
            <form @submit.prevent="onSubmit" @reset.prevent="onReset">
                <div class="p-2">
                    <area-filter ref="areaFilter" :areas="areas" @area-set="setArea" />
                </div>

                <div class="row p-2">
                    <div class="col-4">
                        <span class="search-title">{{ $t('common.start_date') }}</span>
                        <input
                            type="date"
                            id="start_time"
                            v-model="startDate"
                            class="form-control form-control-sm"
                            :locale="$i18n.locale"
                            placeholder="{{ $t('contract_user_reports.choose_date') }}"
                            aria-label="{{ $t('contract_user_reports.choose_date') }}"
                        />
                    </div>
                    <div class="col-4">
                        <span class="search-title">{{ $t('common.end_date') }}</span>
                        <input
                            type="date"
                            id="end_time"
                            v-model="endDate"
                            class="form-control form-control-sm"
                            placeholder="{{ $t('contract_user_reports.choose_date') }}"
                            aria-label="{{ $t('contract_user_reports.choose_date') }}"
                        />
                    </div>
                </div>

                <div class="col-12 button-container mt-3">
                    <button type="submit" class="btn btn-primary form-button">
                        {{ $t('ins_report.search') }}
                    </button>
                    <button type="reset" class="btn btn-danger form-button">
                        {{ $t('ins_report.clear') }}
                    </button>
                </div>
            </form>
        </div>

        <!-- Loading Spinner -->
        <div v-if="loading" id="loader" class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>


<script>
import {restApi} from '../../mixins/RestApiMixin'
import AreaFilter from '../AreaFilter'

export default {
    name: 'AreaReportFilter',
    components: {AreaFilter},
    mixins: [restApi],
    props: {
        areas: {
            type: Array,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            name: null,
            area: null,
            startDate: null,
            endDate: null,
        }
    },
    methods: {
        onReset: function () {
            this.name = null
            this.area = null
            this.startDate = null
            this.endDate = null
            this.$refs.areaFilter.resetData()
        },
        onSubmit: function () {
            let params = {}
            if (this.area) {
                params.area = this.area.id
            }
            if (this.startDate) {
                params.from = this.startDate
            }
            if (this.endDate) {
                params.to = this.endDate
            }
            this.$emit('search', params)
        },

        setArea: function (area) {
            this.area = area
        },

    }
}
</script>
